module.exports = __webpack_public_path__ + "assets/img/s2_tab3_active.dee7321a.png";